import axios from "axios";
import { FETCH_CONTACTS } from "./type";
import { ITEMS_PER_PAGE } from "constants/settings";
import { CONTACTS } from "endpointsConst";

const URL = CONTACTS + "/search";
export function getContacts(query = "", offset) {
    return async (dispatch) => {
        try {
            const res = await axios.get(URL, {
                params: {
                    query,
                    offset,
                    limit: ITEMS_PER_PAGE,
                },
            });
            dispatch({
                type: FETCH_CONTACTS,
                payload: {
                    items: res.data.items,
                    query,
                },
            });
        } catch (error) {
            // TODO handle error
        }
    };
}
